import React, { useRef } from 'react';

import type { Originator } from '../../../../../../core/data-sources/content-components/types.js';

import Author from '../Author.js';
import useCarouselScroll from '../../../../hooks/useCarouselScroll.js';

type CarouselProps = {
  authors: Originator[];
  showCircle: boolean;
  section: string;
};

const Carousel: React.FC<CarouselProps> = ({
  authors,
  showCircle,
  section,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const {
    scrollDirection,
    isOverFlow,
    hasFade,
    handleScroll,
    handleScrollButton,
  } = useCarouselScroll(containerRef);

  return (
    <figure className={`carousel ${hasFade ? 'fade' : ''}`}>
      <div
        className="inner-carousel"
        ref={containerRef}
        onScroll={handleScroll}
      >
        {authors.map((author, index) => (
          <Author
            key={index}
            {...author}
            showCircle={showCircle}
            section={section}
          />
        ))}
      </div>
      {authors.length > 2 && isOverFlow && (
        <div className="arrow-wrapper">
          <button
            onClick={handleScrollButton}
            className={
              scrollDirection === 'right' ? 'arrow-right' : 'arrow-left'
            }
          ></button>
        </div>
      )}
    </figure>
  );
};

export default Carousel;
